import React, { CSSProperties, FC } from 'react'

interface Props {
  extraClasses?: string
  style?: CSSProperties
}

const Arrow: FC<Props> = ({ extraClasses = '', style }) => (
  <span className={`Icon ${extraClasses}`} style={style}>
    <svg className="Icon-glyph" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <title>Arrow</title>
      <path d="M20 12L13.8863 18L12.3579 16.5L15.7204 13.2H3V10.8H15.7204L12.3579 7.5L13.8863 6L20 12Z" />
    </svg>
  </span>
)

export default Arrow
